import React from 'react';
import {connect} from "react-redux";
import {tabNames} from "./constants"
import './CalendarPage.css';
import LeftFrame from "./components/CalendarLeftFrame";
import RightFrame from "./components/CalendarRightFrame";

class CalendarPage extends React.Component {
    componentDidMount() {
        this.props.updateHeader("Calendar Organizer", tabNames.CALENDAR);
    }

    render() {
        return (
            <div id="body">
                <LeftFrame sessionTypes={this.props.sessionTypes}
                           sessions={this.props.sessions}
                           removeSession={this.props.removeSession}
                           user={this.props.user}/>

                <RightFrame sessionTypes={this.props.sessionTypes}
                            sessions={this.props.sessions}
                            user={this.props.user}/>
            </div>
        )
    }
}

export default connect(
    null,
    null
)(CalendarPage);
